/** @format */

import React from 'react';
import TemplateButton from './TemplateButton.js';
import PropTypes from 'prop-types';
import { KeyboardBackspace } from 'mdi-material-ui';
import ButtonInterface from '../../interfaces/forms/Button';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

export const LeftArrowButton = (props: ButtonInterface): React.ReactElement => {
    const { callback, callbackParam, color, text, tooltipTitle, ...rest } = props;
    return (
        <TemplateButton
            {...rest}
            icon={ChevronLeftIcon}
            color={color}
            callback={callback}
            callbackParam={callbackParam}
            text={text}
            tooltipTitle={tooltipTitle}
        />
    );
};

LeftArrowButton.propTypes = {
    callback: PropTypes.func.isRequired,
    callbackParam: PropTypes.object.isRequired,
    color: PropTypes.string,
    text: PropTypes.string,
    disabled: PropTypes.bool,
};

export default LeftArrowButton;
